import axios from 'axios';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import { setupDefaultLanguage } from '@/utils/langUtils';

const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_BASE_API,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});

// 公共方法：处理退出登录
export function handleLogout() {
    store.commit('setUserInfo', null);
    store.commit('setToken', null);
    store.commit('setReadonly', null);
    // store.commit('setAccessType', null);
    store.commit('setIsResponding', false);
    store.commit('setShowLogin', true);
    store.commit('setPermission', null);
    store.commit('setSidebarExpanded', true);
    if (router.currentRoute.name !== 'WecomePage') {
        router.push({ name: 'WecomePage' });
    }
    i18n.locale = setupDefaultLanguage();
}

// 请求拦截器
instance.interceptors.request.use(
    config => {
        const token = store.state.token;
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; 
            // config.headers['Authorization'] = `Bearer aaaa`; 
        }
        config.headers['accept-language'] = i18n.locale
        return config;
    },
    error => Promise.reject(error)
);

// 集中式响应拦截器
instance.interceptors.response.use(
    response => {
        // 如果响应成功且 code 为 200，允许下一个请求
        if (response.data.code === 200) {
            return response;
        } else if (response.status == 200) {
            return response
        } else if(response.data.code === 400){
            return Promise.reject(response.data.data);
        }
    },
    // 网络错误处理
    error => {
        const { status } = error;
        if (error.response) {
            // 处理不同的错误码
            switch (status) {
                case 401:
                    handleLogout();
                    return Promise.reject(i18n.t('system.401Error'));
                case 500:
                    return Promise.reject(i18n.t('system.500Error'));
                case 502:
                    if (router.currentRoute.path !== '/BadGateway') {
                        router.push('/BadGateway');
                    }
                    // store.commit('setAccessType', null);
                    return Promise.reject(i18n.t('system.502Error'));
                default:
                    return Promise.reject(i18n.t('system.defaultError'));
            }
        }
    }
);

export default instance;